import React, { useEffect, useState } from "react"
import "./ViewCourse.scss"
import { Button, Card, CardBody, Col, Row } from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { InputText } from "primereact/inputtext"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import CourseApi from "Api/CourseApi"

const ViewCourse = () => {
  document.title = "View Course"

  const accessToken = localStorage.getItem("accessToken")
  const navigate = useNavigate("")
  const location = useLocation()
  const { courseId } = useParams()
  const [courseData, setCourseData] = useState({})
  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "course", link: "#" },
    { label: "course Details", link: "#" },
  ]

  const getCourse = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    CourseApi.getCourseById(courseId, config)
      .then(res => {
        setCourseData(res.data.courseData)
      })
      .catch(err => {
      })
  }

  useEffect(() => {
    if (courseId) {
      getCourse()
    }
  }, [courseId])

  return (
    <div className="view-course">
      <Row>
        <Col xs="12">
          <div className="course-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb
              data={breadcrumbItems}
              pageTitle="Course Details"
            />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="course-view-form ">
                <div className="course-view-inp">
                  <label htmlFor="university" className="label">
                    university
                  </label>
                  <span
                    className="institution-view-inp-span"
                    onClick={() => {
                      navigate(
                        `/view-university/${courseData?.university?.universityCode}`,
                      )
                    }}
                  >
                    {courseData?.university?.universityName}
                  </span>
                </div>
                <div className="course-view-inp">
                  <label htmlFor="Institution" className="label">
                    Institution
                  </label>
                  <span
                    className="institution-view-inp-span"
                    onClick={() => {
                      navigate(
                        `/view-institution/${courseData?.institution?.institutionCode}`,
                      )
                    }}
                  >
                    {courseData?.institution?.institutionName}
                  </span>
                </div>
                

                <div className="course-view-inp">
                  <label htmlFor="programName" className="label">
                    Program Name
                  </label>
                  <span
                    className="institution-view-inp-span"
                    onClick={() => {
                      navigate(`/view-program/${courseData?.Program?._id}`)
                    }}
                  >
                    {courseData?.Program?.programName}
                  </span>
                </div>

                <div className="course-view-inp">
                  <label htmlFor="courseName" className="label">
                    Course Name
                  </label>

                  <InputText
                    id="courseName"
                    value={courseData?.courseName}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="course-view-inp">
                  <label htmlFor="duration" className="label">
                    Duration
                  </label>
                  <InputText
                    id="duration"
                    value={courseData?.duration}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="course-view-inp">
                  <label htmlFor="level" className="label">
                    Level
                  </label>

                  <InputText
                    id="level"
                    value={courseData?.level}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="course-view-inp">
                  <label htmlFor="eligibilityCriteria" className="label">
                    EligibilityCriteria
                  </label>
                  <InputText
                    id="eligibilityCriteria"
                    value={courseData?.eligibilityCriteria}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="course-view-inp">
                  <label htmlFor="totalSeats" className="label">
                    TotalSeats
                  </label>
                  <InputText
                    id="totalSeats"
                    value={courseData?.totalSeats}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="course-view-inp">
                  <label htmlFor="tuitionFee" className="label">
                    TuitionFee
                  </label>

                  <InputText
                    id="tuitionFee"
                    value={courseData?.tuitionFee}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="course-view-inp">
                  <label htmlFor="admissionFee" className="label">
                    AdmissionFee
                  </label>
                  <InputText
                    id="admissionFee"
                    value={courseData?.admissionFee}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                {/* <div className="course-view-inp">
                  <label htmlFor="Scholarship" className="label">
                    Scholarship
                  </label>
                  <InputText
                    id="Scholarship"
                    value={courseData?.scholarships}
                    className="inp-field-box"
                    disabled
                  />
                </div> */}

                <div className="course-view-inp">
                  <label htmlFor="intakeSeats" className="label">
                    Intake Seats
                  </label>
                  <InputText
                    id="intakeSeats"
                    value={courseData?.intakeSeats}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="course-view-inp">
                  <label htmlFor="modeOfStudy" className="label">
                    modeOfStudy
                  </label>

                  <InputText
                    id="modeOfStudy"
                    value={courseData?.modeOfStudy}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="course-view-inp">
                  <label htmlFor="description" className="label">
                    Description
                  </label>
                  <InputText
                    id="description"
                    value={courseData?.description}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="course-view-inp">
                  <label htmlFor="verifiedStatus" className="label">
                    Verified Status
                  </label>
                  <InputText
                    id="verifiedStatus"
                    value={
                      courseData.verifiedStatus === "approve"
                        ? "Yes"
                        : "No"
                          ? "Yes"
                          : "No"
                    }
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="course-view-inp">
                  <label htmlFor="verifiedReason" className="label">
                    Verified Reason
                  </label>
                  <InputText
                    id="verifiedReason"
                    value={
                      courseData.verifiedReason
                        ? courseData.verifiedReason
                        : "-"
                    }
                    className="inp-field-box"
                    disabled
                  />
                </div>

                {/* Cutoff Section */}
                {courseData?.cutoff && courseData.cutoff.length > 0 && (
                  <div className="course-view-inp">
                    <label className="label">Cutoffs</label>
                    <div className="cutoff-table-container">
                      <table className="cutoff-table">
                        <thead>
                          <tr>
                            <th>Year</th>
                            <th>Quota</th>
                            {courseData?.institution?.category?.toUpperCase() === "MEDICAL" ? (
                              <>
                                <th>Round 1</th>
                                <th>Round 2</th>
                                <th>Mop Up Round</th>
                                <th>Stray Vacancy</th>
                              </>
                            ) : (
                              <th>Cutoff</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {courseData.cutoff.map((cutoff, index) => (
                            <tr key={index}>
                              <td>{cutoff.year}</td>
                              <td>{cutoff.quota}</td>
                              {courseData?.institution?.category?.toUpperCase() === "MEDICAL" ? (
                                <>
                                  <td>{cutoff.rounds?.round1 || "-"}</td>
                                  <td>{cutoff.rounds?.round2 || "-"}</td>
                                  <td>{cutoff.rounds?.mopUpRound || "-"}</td>
                                  <td>{cutoff.rounds?.strayVacancy || "-"}</td>
                                </>
                              ) : (
                                <td>{cutoff.cutoff || "-"}</td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                
              </div>

              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-start gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Back
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default ViewCourse
